<template>
    <base-dialog :loading="loading" :value="dialog" :width="480" :title="$t('common.save_in_blocks')"
        @input="val => { if (!val) hide() }" @close="hide">
        <div class="dlg-fields">
            <kimsa-combobox :label="$tc('common.blocks', 2)" dense :items="blockOptions" @change="block = $event"
                ref="blocks" />
            <kimsa-text-field :label="$t('common.name')" dense force-value :value="name" @change="name = $event" />
            <kimsa-combobox :label="$t('common.folder')" dense :items="folderOptions" item-text="label"
                @change="folder = $event" ref="folders" />
            <kimsa-tags-picker ref="tagsPicker" @change="tags = $event" :default-tags="tags"
                :label="$t('exercises.tags')" force-value />
            <kimsa-upload-file :label="$t('common.image')" relative-path="images/blocks" mime-types="image/*"
                @change="file = $event" :preview-img="previewImg" ref="img" height="150" />
        </div>

        <template v-slot:footer>
            <dialog-actions hide-cancel :confirm-label="$t('common.save')" :disabled="disabled" :loading="loading"
                @confirm="save" />
        </template>
    </base-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { db } from "@/utils/Firebase";
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import KimsaUploadFile from "@/components/common/inputs/KimsaUploadFile";
import KimsaCombobox from "@/components/common/inputs/KimsaCombobox";
import { getPayloadBlock } from "@/utils/Exercises";
import KimsaTagsPicker from '../../common/inputs/KimsaTagsPicker.vue';
import BaseDialog from "@/components/common/BaseDialog";
import DialogActions from "@/components/common/DialogActions";

export default {
    name: "SaveBlockDialog",
    components: { KimsaCombobox, KimsaUploadFile, KimsaTextField, KimsaTagsPicker, BaseDialog, DialogActions },
    props: {
        coachId: {
            type: String,
            default: null
        }
    },
    data(vm) {
        return {
            dialog: false,
            loading: false,
            assignedRoutine: null,
            name: '',
            block: null,
            folder: null,
            tags: [],
            file: null,
        }
    },
    computed: {
        ...mapState(['folders', 'globalFolders']),
        disabled(vm = this) {
            return !vm.block || !vm.name || !vm.folder;
        },
        previewImg(vm = this) {
            return vm.file?.img || null
        },
        folderOptions(vm = this) {
            return [...vm.globalFolders, ...vm.folders].filter(folder => folder.type === 'blocks' && !folder.isCircuit).map(folder => ({ ...folder, id: folder.id, label: vm.folderLabel(folder) })) || []
        },
        blockOptions(vm = this) {
            return Array.from({ length: vm.assignedRoutine?.blocks?.length || 0 }, (_, i) => i + 1)
        }
    },
    async mounted() {
        const vm = this
        if (vm.folders.length === 0) await vm.bindFolders(vm.coachId)
        if (vm.globalFolders.length === 0) await vm.bindGlobalFolders()
    },
    methods: {
        ...mapActions(['bindFolders', 'bindGlobalFolders']),
        show(assignedRoutine) {
            const vm = this
            if (!assignedRoutine) return vm.toast(vm.$t('routines.error_save_routine'), 'error')
            vm.assignedRoutine = assignedRoutine
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.reset()
        },
        reset() {
            const vm = this
            vm.assignedRoutine = null
            vm.name = ''
            if (vm.$refs.blocks) vm.$refs.blocks.model = null
            if (vm.$refs.folders) vm.$refs.folders.model = null
            if (vm.$refs.img) vm.$refs.img.reset()
            vm.block = null
            vm.folder = null
            vm.tags = []
            vm.file = null
        },
        async save() {
            const vm = this
            const { assignedRoutine, name, folder, tags, file } = vm
            await vm.withLoading(async () => {
                const block = assignedRoutine.blocks[vm.block - 1]
                let img = null
                if (file) img = await vm.$refs.img.upload()
                let payload = getPayloadBlock(name, vm.coachId, block, folder, tags, img)
                await db.collection('blocks').add(payload)
                vm.hide()
                vm.toast(vm.$t('common.saved_block'))
            })
        },
    },

}
</script>

<style scoped>
.dlg-fields {
    display: flex;
    flex-direction: column;
    gap: 14px;
}
</style>